/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
const INITIAL_STATE = {
  access_token: null,
  expires_in: null,
  refresh_token: null,
  token_type: null,
  user: null,
  password: null,
};

const signInReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  if (type === 'SIGNIN_RESPONSE_DATA') {
    return {
      ...state,
      access_token: action.response.access_token,
      expires_in: action.response.expires_in,
      refresh_token: action.response.refresh_token,
      token_type: action.response.token_type,
    };
  }
  if (type === 'SINGIN_GET_USER_PASSWORD') {
    return {
      ...state,
      user: action.user,
    };
  }
  return {
    ...state,
  };
};

export default signInReducer;
